var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"onboarding-welcome inside-container onboarding active\"><img" + (jade.attr("src", require('./rent-app-logo-copy.svg'), true, true)) + " width=\"70\" alt=\"Rent Application\"><h2>Welcome to Rent Application</h2><h3>Application for <strong>{{ unit_address }} </strong>has been shared by:</h3><br><h3 style=\"font-weight: 600;\">{{ shared_by }}</h3><br><br><a ng-click=\"$close('start')\" class=\"onboard-button get-started\">Start Tour</a><a href=\"#\" ng-click=\"$close('skip')\" class=\"onboard-skip\">Skip</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/tour/welcome/welcomeModal.jade
// module id = 829
// module chunks = 0